// const axios = require('axios');
import axios from "axios";
import { BASE_URL } from "../api-config/config";
import { generateTokenHandler } from "../utils/json-web";

// const API_URL = "http://localhost:3001";
// const BASE_URL = "http://localhost:3001/";

let customConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const saveContactUsDetails = async (contactDetail) => {
  const slug = await generateTokenHandler();
  customConfig.headers.slug = slug;
  console.log(contactDetail);
  return axios.post(BASE_URL + "contact-us", contactDetail, customConfig);
};

// module.exports = saveContactUsDetails;
